import type { ColumnHAlign } from './export-types';

/**
 * Convert column proportions (summing to 1.0) into absolute autoTable
 * `columnStyles` whose widths exactly fill `usableWidth`. The final column
 * absorbs any floating-point remainder so the table never overflows the page
 * nor falls short of it.
 */
export const buildColumnStyles = (
  proportions: number[],
  usableWidth: number,
  overrides: Record<number, { halign?: ColumnHAlign }> = {},
): Record<string, { cellWidth: number; halign?: ColumnHAlign }> => {
  const styles: Record<string, { cellWidth: number; halign?: ColumnHAlign }> = {};
  let used = 0;
  proportions.forEach((proportion, index) => {
    const isLast = index === proportions.length - 1;
    const cellWidth = isLast
      ? Number((usableWidth - used).toFixed(2))
      : Number((usableWidth * proportion).toFixed(2));
    used += cellWidth;
    styles[index] = { cellWidth, ...overrides[index] };
  });
  return styles;
};
